<template>
    <!--Brand One Start-->
    <section class="brand-one brand-three" style="background-color: #fdfdfdf6 !important;">
            <div class="brand-two-shape-1">
            </div>
            <div class="container">
                <div class="thm-swiper__slider swiper-container" data-swiper-options='{"spaceBetween": 100, "slidesPerView": 5, "autoplay": { "delay": 5000 }, "breakpoints": {
                            "0": {
                                "spaceBetween": 30,
                                "slidesPerView": 2
                            },
                            "375": {
                                "spaceBetween": 30,
                                "slidesPerView": 2
                            },
                            "575": {
                                "spaceBetween": 30,
                                "slidesPerView": 3
                            },
                            "767": {
                                "spaceBetween": 50,
                                "slidesPerView": 4
                            },
                            "991": {
                                "spaceBetween": 50,
                                "slidesPerView": 5
                            },
                            "1199": {
                                "spaceBetween": 100,
                                "slidesPerView": 6
                            }
                        }}'>
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <img src="assets/images/homeBrand/IEHlcontrol-logo.png" alt="">
                        </div><!-- /.swiper-slide -->
                        <div class="swiper-slide">
                            <img src="assets/images/homeBrand/dura-logo.png" alt="">
                        </div><!-- /.swiper-slide -->
                        <div class="swiper-slide">
                            <img src="assets/images/homeBrand/mitsubishi-logo.png" alt="">
                        </div><!-- /.swiper-slide -->
                        <div class="swiper-slide">
                            <img src="assets/images/homeBrand/stairs-logo.png" alt="">
                        </div><!-- /.swiper-slide -->
                        <div class="swiper-slide">
                            <img src="assets/images/homeBrand/pentax-logo.png" alt="">
                        </div><!-- /.swiper-slide -->
                        <div class="swiper-slide">
                            <img src="assets/images/homeBrand/ksb-logo.png" alt="">
                        </div><!-- /.swiper-slide -->
                        <div class="swiper-slide">
                            <img src="assets/images/homeBrand/tecnidro-logo.png" alt="">
                        </div><!-- /.swiper-slide -->

                    </div>
                </div>
            </div>
        </section>
        <!--Brand One End-->

</template>

<script>
      export default {
        mounted(){
            this.thmSwiperInit();
        },
        methods:{
            thmSwiperInit() {
                // swiper slider
                if ($(".thm-swiper__slider").length) {
                $(".thm-swiper__slider").each(function () {
                    let elm = $(this);
                    let options = elm.data("swiper-options");
                    let thmSwiperSlider = new Swiper(elm, options);
                });
                }
            }
        }
    }
</script>